import React, { useEffect, useState } from 'react';
import Grid from '@mui/material/Grid2';
import { withStyles } from '@mui/styles';
import AppAnimate from '../../../components/AppAnimate';
import { useSnackbar } from 'notistack';
import axios from 'axios';
import { defaultVariables } from '../../../../config';
import ItemsSkeleton from '../../../components/loaders/ItemsSkeleton';
import { useTranslation } from 'react-i18next';
import InfiniteScroll from 'react-infinite-scroll-component';
import {Box, CircularProgress, Typography} from '@mui/material';
import Title from '../../../components/elements/Title';
import {getMediaURL, scrollTop} from '../../../../config/values';
import NothingFound from "../../../components/elements/NothingFound";
import {ChevronLeft, CircleSlash2, PackageOpen} from "lucide-react";
import Button from "@mui/material/Button";
import {Link} from "react-router-dom";
import Container from "@mui/material/Container";
import {Styles} from "../../../../config/design/styles";
import CharityCardFront from "../components/charities/CharityCardFront";
import DonorsTable from "../../manage/charities/components/DonorsTable";
import RecentDonates from "../../manage/charities/components/RecetDonates";
import BannersLoader from "../components/BannersLoader";
import CharitiesPageSkeleton from "../../../components/loaders/CharitiesPageSkeleton";


function CharitiesPage({ classes }) {
    const { t } = useTranslation();
    const { enqueueSnackbar } = useSnackbar();

    const [items, setItems] = useState([]);
    const [hasMore, setHasMore] = useState(true);
    const [loading, setLoading] = useState(false);
    const [banners, setBanners] = useState([]);
    const [initialLoad, setInitialLoad] = useState(true);
    const [page, setPage] = useState(1);

    const config = {
        headers: {
            Accept: 'application/json',
        }
    };

    const loadData = async (page = 1, append = false) => {
        try {
            setLoading(true);

            const response = await axios.get(
                `${defaultVariables.url}/front/charities?page=${page}`,
                config
            );
            setItems((prev) => append ? [...prev, ...response.data.data] : response.data.data);
            setHasMore(response.data.data.length > 0);

        } catch (error) {
            enqueueSnackbar('Error fetching orders. Please try again.', { variant: 'error' });
            console.log(error.response)
        } finally {
            setLoading(false);
            setInitialLoad(false);

        }
    };

    useEffect(() => {
        loadData();
        scrollTop();
    }, []);

    const loadMore = () => {
        if (!loading && hasMore) {
            const nextPage = page + 1;
            setPage(nextPage);
            loadData(nextPage, true);
        }
    };

    return (
        <AppAnimate animation='transition.slideUpIn' delay={200} title={t('charities')}>
            <div className={classes.discoverLayout}>
                <Container maxWidth="xl" >
                    <Grid container spacing={2} justifyContent="center" className={classes.bannerSliderItem}>
                        <Grid item size={12}>
                            <BannersLoader position="charities_top_banners"/>
                        </Grid>
                        <Grid item size={12} className="flex-space">
                            <Title align="left" color="text" className="panel-title">{t('charities')}</Title>
                        </Grid>
                        {
                            initialLoad ?

                                <>
                                    <Grid item size={12}>
                                        <CharitiesPageSkeleton/>
                                    </Grid>
                                </>
                                : (
                                <>
                                    {
                                        !!items.length &&
                                        <Grid item size={12}>
                                            <InfiniteScroll
                                                dataLength={items.length}
                                                next={loadMore}
                                                hasMore={hasMore}
                                                loader={(
                                                    <div style={{ textAlign: 'center', padding: '20px 0' }}>
                                                        {loading && <CircularProgress />}
                                                    </div>
                                                )}
                                            >
                                                <Grid container spacing={2}>
                                                    <Grid item size={{xs:12,md:8,lg:9}} >
                                                       <Grid container spacing={2}>
                                                           {items.map((item, index) => (
                                                               <Grid item size={{xs:6,md:6,lg:4}} key={item.id}>
                                                                   <CharityCardFront item={item}/>
                                                               </Grid>
                                                           ))}
                                                       </Grid>
                                                    </Grid>
                                                    <Grid item size={{xs:12,md:4,lg:3}} >
                                                       <Box className="bg-top-border">
                                                           <DonorsTable/>
                                                           <RecentDonates/>
                                                       </Box>
                                                    </Grid>
                                                </Grid>
                                            </InfiniteScroll>
                                        </Grid>
                                    }
                                    {!initialLoad && items.length === 0 && (
                                        <Grid item size={12}>
                                            <NothingFound
                                                type="page"
                                                title={t('nothingFound')}
                                                title_color="text"
                                                paragraph={t('noCharityFoundDec')}
                                                icon={<CircleSlash2/>}
                                            >
                                                <Button
                                                    variant="outlined"
                                                    startIcon={<ChevronLeft/>}
                                                    component={Link}
                                                    to={`/`}
                                                >
                                                    {t('back')}
                                                </Button>
                                            </NothingFound>
                                        </Grid>
                                    )}

                                </>
                            )
                        }


                    </Grid>
                </Container>
            </div>
        </AppAnimate>
    );
}
export default withStyles(Styles)(CharitiesPage);

